export default {
  title: 'Pedido N.º {{number}}',
  labels: {
    item: '{{count}} item',
    item_other: '{{count}} itens',
  },
  buttons: {
    details: 'Detalhes',
  },
  fulfillment_statuses: {
    created: 'Criado',
    reviewed: 'Revisto',
    accepted: 'Aceite',
    preparing: 'Em preparação',
    ready: 'Pronto',
    on_delivery: 'Em entrega',
    picked: 'Levantado',
    rejected: 'Rejeitado',
  },
};
